import i18n from "src/i18n/i18n";
import { getProductName } from "src/envService";

export const ReportContent = {
  // Use i18n keys and resolve at call/render time
  get SKILLS_REPORT_TITLE() {
    return i18n.t("experiences.report.skillsReportTitle");
  },
  get SKILLS_DESCRIPTION_TITLE() {
    return i18n.t("experiences.report.skillsDescriptionTitle");
  },
  get EXPERIENCES_TITLE() {
    return i18n.t("experiences.report.experiencesTitle");
  },
  get SELF_EMPLOYMENT_TITLE() {
    return i18n.t("experiences.report.selfEmploymentTitle");
  },
  get SALARY_WORK_TITLE() {
    return i18n.t("experiences.report.salaryWorkTitle");
  },
  get UNPAID_WORK_TITLE() {
    return i18n.t("experiences.report.unpaidWorkTitle");
  },
  get TRAINEE_WORK_TITLE() {
    return i18n.t("experiences.report.traineeWorkTitle");
  },
  get UNCATEGORIZED_TITLE() {
    return i18n.t("experiences.report.uncategorizedTitle");
  },
  get TOP_SKILLS_TITLE() {
    return i18n.t("experiences.report.topSkillsTitle");
  },
  get SKILLS_DESCRIPTION_TEXT() {
    return i18n.t("experiences.report.skillsDescriptionText", { appName: getProductName() });
  },
  get DISCLAIMER_TEXT_PART1() {
    return i18n.t("experiences.report.disclaimer.part1");
  },
  get DISCLAIMER_TEXT_PART2() {
    return i18n.t("experiences.report.disclaimer.part2");
  },
  get DISCLAIMER_TEXT_PART3() {
    return i18n.t("experiences.report.disclaimer.part3", { appName: getProductName() });
  },
  REPORT_BODY_TEXT: (currentDate: string) =>
    i18n.t("experiences.report.bodyText", { date: currentDate, appName: getProductName() }),
  IMAGE_URLS: {
    NJILA_LOGO: `${process.env.PUBLIC_URL}/njila-logo-dark.svg`,
    OXFORD_LOGO: `${process.env.PUBLIC_URL}/oxford-logo.png`,
    LOCATION_ICON: `${process.env.PUBLIC_URL}/location.png`,
    PHONE_ICON: `${process.env.PUBLIC_URL}/phone.png`,
    EMAIL_ICON: `${process.env.PUBLIC_URL}/email.png`,
    EDUCATION_ICON: `${process.env.PUBLIC_URL}/trainee-work.png`,
    EMPLOYEE_ICON: `${process.env.PUBLIC_URL}/employee.png`,
    SELF_EMPLOYMENT_ICON: `${process.env.PUBLIC_URL}/self-employment.png`,
    COMMUNITY_WORK_ICON: `${process.env.PUBLIC_URL}/community-work.png`,
    TRAINEE_WORK_ICON: `${process.env.PUBLIC_URL}/trainee-work.png`,
    WARNING_ICON: `${process.env.PUBLIC_URL}/warning.png`,
    QUIZ_ICON: `${process.env.PUBLIC_URL}/quiz.png`,
  },
};
